if (!customElements.get('joyway-product-card')) {
  class JoywayProductCard extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.toggle = this.querySelector('[data-jw-toggle]');
      this.interior = this.querySelector('.jw-card-photo--interior');
      this.exterior = this.querySelector('.jw-card-photo--exterior');
      this.status = this.querySelector('[data-jw-status]');
      this.pinned = false;
      if (!this.toggle || !this.interior) return;
      this.ready = false;
      const image = this.interior.querySelector('img');
      const onReady = () => {
        if (!image.naturalWidth) return;
        this.ready = true;
        this.classList.add('is-interior-ready');
        this.toggle.disabled = false;
        if (this.hovering || this.pinned) this.show(true);
      };
      const onError = () => {
        this.ready = false;
        this.toggle.hidden = true;
        this.classList.remove('is-interior-ready');
        this.pinned = false;
        this.show(false);
      };
      image.addEventListener('load', onReady, options);
      image.addEventListener('error', onError, options);
      if (image.complete) image.naturalWidth ? onReady() : onError();
      this.toggle.addEventListener('click', () => {
        if (!this.ready) return;
        this.pinned = !this.classList.contains('is-showing-interior');
        this.show(this.pinned);
        if (this.status) this.status.textContent = this.pinned ? this.dataset.interiorStatus : this.dataset.exteriorStatus;
      }, options);
      const media = this.querySelector('.jw-card-image-link');
      media.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse' && matchMedia('(hover: hover) and (pointer: fine)').matches) {
          this.hovering = true;
          if (this.ready) this.show(true);
        }
      }, options);
      media.addEventListener('pointerleave', () => {
        this.hovering = false;
        this.show(this.pinned);
      }, options);
      this.querySelector('.jw-card-image-link').addEventListener('focus', () => this.show(this.ready || this.pinned), options);
      this.querySelector('.jw-card-image-link').addEventListener('blur', () => this.show(this.pinned || this.hovering), options);
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          this.pinned = false;
          this.hovering = false;
          this.show(false);
        }
      }, options);
    }
    show(interior) {
      const active = Boolean(interior && this.ready);
      this.classList.toggle('is-showing-interior', active);
      this.toggle?.setAttribute('aria-pressed', String(this.pinned && active));
      this.interior?.setAttribute('aria-hidden', String(!active));
      this.exterior?.setAttribute('aria-hidden', String(active));
      if (this.toggle) {
        this.toggle.setAttribute('aria-label', active ? this.dataset.exteriorLabel : this.dataset.interiorLabel);
        this.toggle.querySelector('span').textContent = active ? this.dataset.exteriorText : this.dataset.interiorText;
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  }
  customElements.define('joyway-product-card', JoywayProductCard);
}
